import {configureStore, ThunkAction, Action} from "@reduxjs/toolkit";
import postReducer from "./slices/post";
import movieReducer from "./slices/movie";

export const store = configureStore({
    reducer: {
        post: postReducer,
        movie: movieReducer
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType,
    RootState,
    unknown,
    Action<string>>;